import * as React from 'react';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {INTEGRATIONS_DATA} from 'shells/integrations/integrations-page-content/integrations-data';
import {IntegrationsPageContent} from 'shells/integrations/integrations-page-content/integrations-page-content';

type Props = ContextRouter;

export function IntegrationsListPage(props: Props) {
    const {category} = props.match.params;

    return (
        <IntegrationsPageContent
            category={category || 'all'}
            // @ts-expect-error
            integrations={INTEGRATIONS_DATA}
            handleClick={(integrationId) => {
                if (integrationId === 'nutshell-iq') {
                    window.open(
                        'https://support.nutshell.com/en/articles/9824079-nutshell-iq-learn-all-about-nutshell-iq-data',
                        '_blank'
                    );
                } else if (integrationId === 'ringcentral-appconnect') {
                    window.open(
                        'https://chromewebstore.google.com/detail/ringcentral-app-connect-b/bgpkbcidaabaeioilooghlffdcmlimgk',
                        '_blank'
                    );
                } else {
                    const matchingCategory = getCategoryFromIntegrationId(integrationId);

                    // Redirect instant integrations to instant page or the respective page in-app
                    if (matchingCategory === 'instant') {
                        props.history.push(getRouteForInstantIntegration(integrationId));
                    } else {
                        props.history.push(
                            `/setup/integration/${matchingCategory || ''}/${integrationId || ''}`
                        );
                    }
                }
            }}
        />
    );
}

// @ts-expect-error
function getCategoryFromIntegrationId(integrationId) {
    // find the proper category for the integration id
    const matchingItem = INTEGRATIONS_DATA.find(
        (integration) => integration.integrationId === integrationId
    );

    let matchingCategory = '';
    if (matchingItem && matchingItem.categoryId) {
        matchingCategory = matchingItem.categoryId[0];
    }

    return matchingCategory;
}

// @ts-expect-error
function getRouteForInstantIntegration(integrationId) {
    switch (integrationId) {
        case 'nutshell-sms':
            return '/inbox/settings/sms';
        case 'nutshell-webchat':
            return '/inbox/settings/chat/config';
        case 'nutshell-quotes':
            return '/sales/quote-template';
        case 'nutshell-campaigns':
            return '/email-marketing/summary';
        case 'nutshell-smsmarketing':
            return '/marketing/sms-setup';
        case 'whatsapp':
            return '/inbox/settings/whatsapp';
        case 'facebook-messenger':
        case 'instagram':
            return '/inbox/settings/facebook';
        case 'callrail':
        case 'aircall':
        case 'ringcentral':
        case 'kixie':
        case 'dialpad':
            return '/my-account/phone';
        default:
            return '/setup/integration/instant';
    }
}
